export const SUGGESTIONS = {
    general: [
        "Team Leadership", "Project Management", "Strategic Planning", "Public Speaking", "Data Analysis"
    ],
    tech: [
        "React", "Node.js", "Python", "AWS", "Docker", "Kubernetes", "TypeScript", "SQL"
    ],
    design: [
        "Figma", "Adobe CC", "UI/UX", "Prototyping", "Wireframing", "User Research"
    ],
    marketing: [
        "SEO", "Content Strategy", "Social Media", "Google Analytics", "Email Marketing"
    ],
    verbs: [
        "Spearheaded", "Orchestrated", "Developed", "Implemented", "Accelerated", "Optimized", "Designed"
    ]
};

export const INITIAL_RESUME = {
    personal: {
        fullName: "",
        email: "",
        phone: "",
        location: "",
        summary: ""
    },
    experience: [],
    education: [],
    skills: [],
    customSections: [],
    sectionOrder: ['experience', 'education', 'skills']
};
